$(window).load(function() {

	/* ---------------------------------------- */
	/* ----- >>> Retina Display --------------- */
	/* ---------------------------------------- */

	var pixelRatio = !!window.devicePixelRatio ? window.devicePixelRatio : 1;
	if (pixelRatio > 1) {
		$('img').each(function() {
			$(this).attr('src', $(this).attr('src').replace("@1x","@2x"));
		});
	}
	
});

$(document).ready(function () {

	/* ---------------------------------------- */
	/* ----- >>> Navigation ------------------- */
	/* ---------------------------------------- */

	$('header').onePageNav({
		currentClass: 'isSelect',
		changeHash: false,
		scrollSpeed: 500
	});


	/* ---------------------------------------- */
	/* ----- >>> Main Menu -------------------- */
	/* ---------------------------------------- */

	if($(window).width() < 640) {
		$('.setMenu').click(function(){
			$('.setMenu .setIcon').toggleClass('isOpen');
			$('.setNav').slideToggle('fast');
		});
	}

	/* ---------------------------------------- */
	/* ----- >>> Menu ------------------------- */
	/* ---------------------------------------- */

	$('nav > ul > li > a[href^="#"]').click( function(e) {
		var setTarget = $(this).attr('href');
		$(setTarget).slideToggle('fast');
		e.preventDefault();
	})

	$('header').mouseleave(function() {
		$('#isSRC').slideUp(100);
	});

	/* ---------------------------------------- */
	/* ----- >>> Media Accordion -------------- */
	/* ---------------------------------------- */

	(function ($) {
		$('dl > dt').on('click', function (e) {

			isTrigger = $(this);
			isTarget  = isTrigger.next();
			if (!isTrigger.hasClass('isOpen')) {
				isTrigger.parent().children('dd').slideUp('fast');
				$('dl > dt').removeClass('isOpen');
				isTrigger.addClass('isOpen');
				isTarget.slideDown('fast');
			} else {
				isTrigger.parent().children('dd').slideUp('fast');
				$('dl > dt').removeClass('isOpen');
			}
			e.preventDefault();
			return false;
		});
	})(jQuery);

	/* ---------------------------------------- */
	/* ----- >>> Stick Header ----------------- */
	/* ---------------------------------------- */

	$(function () {
		var setTarget = $('header');
		var setObject = $(window).height() / 100;
		var setSlider = $(window).height();
		var setWindow = $(window);
		var setScroll = setWindow.scrollTop();
		if (setObject != 0 ) {
			setWindow.scroll(function () {
				var setScroll = setWindow.scrollTop();
				if (setScroll > setObject) {
					setTarget.addClass('onTop')
				} else {
					setTarget.removeClass('onTop');
				}
			});
		} else {
			setTarget.addClass('onTop');
		}
	});

	/* ---------------------------------------- */
	/* ----- >>> Slide Content ---------------- */
	/* ---------------------------------------- */

	var setSlider = new Swiper('.setSlider', {
		centeredSlides	: true,
		slidesPerView	: 1,
		initialSlide 	: 0,
		spaceBetween	: 32,
		loop			: false,
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween : 32,
				initialSlide : 0,
			},
			800: {
				slidesPerView: 2,
				spaceBetween : 24,
				initialSlide : 0,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween : 32,
				initialSlide : 1,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween : 48,
				initialSlide : 1,
			},
		}
	});

	var setBoxes = new Swiper('.setBoxes', {
		slidesPerView	: 1,
		spaceBetween	: 0,
		loop			: $('.setBoxes').data('loop'),
		navigation: {
			prevEl: '.setContent .setPrev',
			nextEl: '.setContent .setNext',
		},
		pagination		: {
			el 			: '.setContent .setDots',
			bulletClass : 'setDot',
			bulletActiveClass: 'isCurrent',
			clickable	: true
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween : 0,
			},
			800: {
				slidesPerView: 2,
				spaceBetween : 24,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween : 32,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween : 48,
			},
		}
	});

	var setTHB = new Swiper('.setThumbnails', {
		watchSlidesVisibility: true,
		watchSlidesProgress  : true,
		slidesPerView        : 3,
		spaceBetween         : 16,
	});

	var setGAL = new Swiper('.setGallery', {
		slidesPerView	: 1,
		effect 			: 'fade',
		thumbs: {
			swiper: setTHB
		}
	});

	/* ---------------------------------------- */
	/* ----- >>> Pantonera -------------------- */
	/* ---------------------------------------- */

	var setPantone = new Swiper('.setPantone', {
		slidesPerView	: 1,
		initialSlide 	: 1,
		autoHeight		: true,
		noSwiping		: true,
		allowTouchMove	: false,
		navigation: {
			prevEl: '.setControls .setPrev',
			nextEl: '.setControls .setNext',
		},
		on: {
			slideChange: function (swiper) {
				if (this.activeIndex == 1) {

				} else {

				}
			},
		}
	});

	$('.setTrigger').click(setPantone,function(){
		var getSlide = $(this).data('slide');
		setPantone.slideTo(getSlide);
	});

	/* ---------------------------------------- */
	/* ----- >>> Club Delirio------------------ */
	/* ---------------------------------------- */

	var setClub = new Swiper('.setSteps', {
		slidesPerView	: 1,
		allowTouchMove 	: false,
		noSwiping		: false,
		draggable		: false,
		loop			: false,
		hashNavigation: {
			watchState: true,
		},
		autoHeight		: true,
	});

	setClub.on('slideChange', function () {
		var setSlide  = this.activeIndex + 1
		var setTarget = '.setPaths nav > ul > li:nth-child('+setSlide+')';
		$('.setPaths nav > ul > li').removeClass('isCurrent');
		$(setTarget).addClass('isActive');
		$(setTarget).addClass('isCurrent');
	});

	$('.setPaths nav > ul > li').click( function(e) {
		var getSlide = $(this).data('slide');
		if ($(this).hasClass('isActive')) {
			setClub.slideTo($(this).index());
		}
		e.preventDefault();
	})

	// ----->>> Inputs

	var isEm		= $('#isEm');
	var isZc		= $('#isZc');
	var isO1		= $('#isO1');
	var isO2		= $('#isO2');
	var isO3		= $('#isO3');

	// ----->>> Validate E-mail

	validateEmail = function (email) {
		if (/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/.test(email.val().toLowerCase())) {
			return true;
		} else {
			return false
		}
	}

	$('#isClub').submit(function () {
		$('.setOutput span').text('');
		if (!validateEmail(isEm)) {
			setOutput = 'Ingresa tu Email'
		} else if (isZc.val() == '') {
			setOutput = 'Ingresa tu Código Postal'
		} else if ( isZc.val() == '28001' || isZc.val() == '28002' || isZc.val() == '28003' || isZc.val() == '28004' || isZc.val() == '28005' || isZc.val() == '28006' || isZc.val() == '28007' || isZc.val() == '28008' || isZc.val() == '28009' || isZc.val() == '28010' || isZc.val() == '28012' || isZc.val() == '28013' || isZc.val() == '28014' || isZc.val() == '28015' || isZc.val() == '28016' || isZc.val() == '28020' || isZc.val() == '28028' || isZc.val() == '28029' || isZc.val() == '28036' || isZc.val() == '28039' || isZc.val() == '28040' || isZc.val() == '28045' || isZc.val() == '28046') {
			 if (isZc.val() == '28002' || isZc.val() == '28006' || isZc.val() == '28016' || isZc.val() == '28028' || isZc.val() == '28036') {
			 	$('.setPlans > .setTAC > strong > span').text('martes');
			 } else if (isZc.val() == '28001' || isZc.val() == '28007' || isZc.val() == '28009' || isZc.val() == '28014' || isZc.val() == '28045') {
			 	$('.setPlans > .setTAC > strong > span').text('miércoles');
			 } else if (isZc.val() == '28003' || isZc.val() == '28020' || isZc.val() == '28029' || isZc.val() == '28039' || isZc.val() == '28040' || isZc.val() == '28046') {
			 	$('.setPlans > .setTAC > strong > span').text('jueves');
			 } else if (isZc.val() == '28004' || isZc.val() == '28005' || isZc.val() == '28008' || isZc.val() == '28010' || isZc.val() == '28012' || isZc.val() == '28013' || isZc.val() == '28015') {
			 	$('.setPlans > .setTAC > strong > span').text('viernes');
			 }
			setOutput = ''
			setClub.slideNext();
		} else if ( isEm.val() != '' && isZc.val() != '28001' && isZc.val() != '28002' && isZc.val() != '28003' && isZc.val() != '28004' && isZc.val() != '28005' && isZc.val() != '28006' && isZc.val() != '28007' && isZc.val() != '28008' && isZc.val() != '28009' && isZc.val() != '28010' && isZc.val() != '28012' && isZc.val() != '28013' && isZc.val() != '28014' && isZc.val() != '28015' && isZc.val() != '28016' && isZc.val() != '28020' && isZc.val() != '28028' && isZc.val() != '28029' && isZc.val() != '28036' && isZc.val() != '28039' && isZc.val() != '28040' && isZc.val() != '28045' && isZc.val() != '28046' ) { 
			$('.setIntro').hide();
			$('.setWaitlist').show();
			$('.setButton',this).val('Avisame');
			return false;
		}
		
		$('.setOutput span').fadeIn('fast').text(setOutput).delay(5000).fadeOut('fast');
		return false;

	});

	$('.setSteps .setOptions > li > a').click( function(e) {
		$('.setSteps .setOptions > li').removeClass('isSelected');
		$('.setSteps .setStep:last-child form').hide();
		$(this).parent().addClass('isSelected');
		$($(this).attr('href')).show();
		e.preventDefault();
	})

	$('.setStep .setGrid > div').click( function(e) {
		var getFM = $(this).data('form');
		var getID = $(this).data('id');		
		
		$('.setStep .setGrid > div').removeClass('isSelected');
		$(this).addClass('isSelected');
		
		$('#'+getFM+' #setVariants option').removeAttr('selected');
		var setTRG = $('#'+getFM+' #setVariants option[value='+ getID +"]")
		
		setTRG.attr('selected', true);
		if (!setTRG.is(':disabled')) {
			setTRG.attr('selected', true);
		}
		
		e.preventDefault();
	})

	$('.getNext').click( function(e) {
		setClub.slideNext();
		e.preventDefault();
	})

	/* ---------------------------------------- */
	/* ----- >>> Modal ------------------------ */
	/* ---------------------------------------- */

	$('[data-fancybox]').fancybox({
		touch: false
	});
	
	/* ---------------------------------------- */
	/* ----- >>> Cart Quantity ---------------- */
	/* ---------------------------------------- */

	$('#getCart').getUpdate({
		getItem 	: '.setItem',
		getQtty		: '.setQty',
		getSbtl		: '.setMath',
		getTotal	: '.setTotal',
		getItems 	: '.setCount'
	});

	$('.setMyCart .setClose, .setMyCart .setContinue').click(function() {
		$('.setMyCart').fadeOut('fast')
	})
	
	/*
	$('.setLess').click( function() {
		var setInput = $(this).parent().find('.setQtty')
		var setLimit = setInput.attr('min');
		var setValue = +setInput.val() - 1
		if ( setValue >= setLimit ) {
			setInput.val( setValue ).blur();
		}
		return false;
	})
    
	$('.setMore').click( function() {
		var setInput = $(this).parent().find('.setQtty')
		var setLimit = setInput.attr('max');
		var setValue = +setInput.val() + 1
		if ( setValue <= setLimit ) {
			setInput.val( setValue ).blur();
		}
      	return false;
	})
	*/

	$('.setBasket .setClose').click(function(e) {
		$('.setBasket').fadeOut('fast')
		e.preventDefault();
	})

	/* ---------------------------------------- */
	/* ----- >>> Variants --------------------- */
	/* ---------------------------------------- */

	$('section .setSelect select').on('change', function() {     

		var setVRT = $('.setSelect').length;
		var setVTS = '';
		for (var i = 0; i < setVRT; i++) {
			var setVTO = $('.setSelect select#setID'+i).val()
			setVTS = setVTS+' / '+setVTO
		}

		setVTS = setVTS.substring(3);

		setUpdate($('#setVariants option:contains('+setVTS+')').val());

		/* ---------------------------------------- */

		$('#setVariants option').removeAttr('selected');
		var setTRG = $('#setVariants option:contains('+setVTS+')')

		if (!setTRG.is(':disabled')) {
			setTRG.attr('selected', true);
		}
		console.log('NO')

	});

	$('#isRSV select').on('change', function() {
		var setDates = $('#setID0').val();
		var setItems = $('#setID1').val();
		var setPlace = $('#setID4').val();
		var setHours = $('#setID5').val();

		console.log(setPlace);

		if (setDates == '24 / 12 / 2022' || setDates == '31 / 12 / 2022' || setDates == '07 / 01 / 2023' || setDates == '08 / 01 / 2023') {
			$('#setID5 option:nth-child(4), #setID5 option:nth-child(5)').hide();
		} else if (setPlace == 'C/ Naranjo 7') {
			$('#setID5 option:nth-child(4), #setID5 option:nth-child(5)').hide();
		}else {
			$('#setID5 option:nth-child(4), #setID5 option:nth-child(5)').show();
		}

		/*var setVar = $(this).val();
		if (setVar == '11/12/2022' || setVar == '12/12/2022' || setVar == '18/12/2022' || setVar == '19/12/2022' || setVar == '24/12/2022' || setVar == '26/12/2022' || setVar == '31/12/2022' || setVar == '02/01/2023' || setVar == '06/01/2023' || setVar == '08/01/2023' || setVar == '09/01/2023') {
			$('#setID5 option:nth-child(4), #setID5 option:nth-child(5)').hide();
		} else {
			$('#setID5 option:nth-child(4), #setID5 option:nth-child(5)').show();
		}*/
	});
  
	function setUpdate(setVar) {
		$.each(getJSON.variants, function(i){
			if (setVar == getJSON.variants[i].id) {
				var setPRC = getJSON.variants[i].price;
				var setAVL = getJSON.variants[i].available;
				var setCMP = getJSON.variants[i].compare_at_price;

				if (setCMP != null ) {
					$('.setPRC').html('<del>'+getMoney (setCMP)+'</del><em>'+getMoney (setPRC)+'</em> ud.');
				} else {
					$('.setPRC').html('<em>'+getMoney (setPRC)+'</em> ud.');
				}

				if (setAVL == true) {
					$('.setSubmit .setButton').val('Añadir a la cesta').attr('disabled', false);
					$('.setLess').attr('disabled', false);
					$('.setMore').attr('disabled', false);
					$('.setQtty').val('1');
				} else {
					$('.setSubmit .setButton').val('Agotado').attr('disabled', true);
					$('.setLess').attr('disabled', true);
					$('.setMore').attr('disabled', true);
					$('.setQtty').val('0');
				}
			}
		})
	}	

	function getMoney (setVar) {
		return '€'+setVar.toString().slice(0, -2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')+','+setVar.toString().slice(-2);
	}
	/* ---------------------------------------- */
	/* ----- >>> Media Accordion -------------- */
	/* ---------------------------------------- */

	$('.getEdit').click( function(event) {
		var setTarget = $(this).attr('href');
		$('.isOpen').slideToggle(0).removeClass('isOpen')
		$(setTarget).slideToggle(0).addClass('isOpen');
		event.preventDefault();
	})

	$('.getClose').click( function(event) {
		$('.isOpen').slideToggle(0).removeClass('isOpen')
		$('#isADS00').slideToggle(0).addClass('isOpen');
		event.preventDefault();
	})

	$('.getRemove').click( function(event) {
		var setTarget = $(this).attr('href');
		$(setTarget).trigger('click');
		event.preventDefault();
	})

	/* ---------------------------------------- */
	/* ----- >>> Modal ------------------------ */
	/* ---------------------------------------- */

	$('#getModal').click( function(e) {
		$('.setModal').fadeIn('fast');
		e.preventDefault();
	})

	$('.setModal .setClose').click( function(e) {
		$('.setModal').fadeOut('fast');
	})
	
	/* ---------------------------------------- */
	/* ----- >>> Sticky Footer ---------------- */
	/* ---------------------------------------- */

	var wHeight = $(window).height();
	var dHeight = $(document).height();
	if (wHeight >= dHeight) {
		$('footer').css('position','fixed').css('bottom',0);
	}

	/* ---------------------------------------- */
	/* ----- >>> Set Uniform Js --------------- */
	/* ---------------------------------------- */

	$('select, input[type=checkbox], input[type=radio], input[type=file]').uniform();

});